<form *ngIf="fields" [formGroup]="addEditForm" (ngSubmit)="saveOrUpdate(dialogBoxEmployment)" RestrictFocus>
  <div class="ui-grid ui-grid-responsive ui-fluid" >
    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !fields.name}">{{ fields.name.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <input type="text" formControlName="name" pInputText />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.name"></app-validation-msg>
      </div>
    </div>
  </div>
  <p-footer>
    <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix" style="text-align: center; border: none;">
      <button
      class="k-generic-btn"
      type="submit" pButton
      icon="fa fa-check"
      label="{{('common.save' | translate)}}"
      ></button>
    </div>
  </p-footer>
</form>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/employment/employmentForm.html